"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockCreateApiCredentials = exports.mockApiCredentials = void 0;
exports.mockApiCredentials = {
    success: true,
    apiCredentials: [
        {
            id: 1,
            tenant: 'test',
            licenseId: 2,
            apiKey: '0cd51cac7a8cd271629f8db0ae5beaba1c686f68',
            encryptedToken: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX3V1aWQiOiI5MDQ0MzRiYS05ODU4LTQ5MjEtOWY1Ny1kNDcwMTdhNmVlZjciLCJ1c2VyX2lkIjoxLCJyb2xlIjoiY3VzdG9tZXJfYWRtaW4iLCJ1c2VyX2VtYWlsIjoiYWRtaW5AY29kZWJhc2hpbmcuY29tIiwidGVuYW50IjoibWF0cml4IiwiZW52IjpudWxsLCJsaWNlbnNlX2lkIjoyLCJpc19sZWFuX2xpY2Vuc2UiOnRydWUsImZlYXR1cmVzIjp7ImRpc3BsYXlfbmlja25hbWVzIjpmYWxzZSwiY29udGVudF9tYW5hZ2VtZW50IjpmYWxzZSwiY2VydGlmaWNhdGVfbGlua2VkaW5fc2hhcmUiOmZhbHNlLCJhbGxvd19jaGFuZ2VfcHJpbWFyeV9jb3Vyc2UiOmZhbHNlfSwiaWF0IjoxNzEyNTU5MzUyLCJleHAiOjE3MTI1NTkzNTJ9.7j8YCsrVk5OqZtgOXZxp5QaF02nf5ZJ8JLcEM9GI-tE',
            name: 'Codebashing',
            expiration: '30d',
            isNew: true,
            isExpired: false,
        },
        {
            id: 2,
            tenant: 'test',
            licenseId: 2,
            apiKey: '926d50a9add67ab3ef60ac9d640c7f56149c945a',
            encryptedToken: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX3V1aWQiOiI5MDQ0MzRiYS05ODU4LTQ5MjEtOWY1Ny1kNDcwMTdhNmVlZjciLCJ1c2VyX2lkIjoxLCJyb2xlIjoiY3VzdG9tZXJfYWRtaW4iLCJ1c2VyX2VtYWlsIjoiYWRtaW5AY29kZWJhc2hpbmcuY29tIiwidGVuYW50IjoibWF0cml4IiwiZW52IjpudWxsLCJsaWNlbnNlX2lkIjoyLCJpc19sZWFuX2xpY2Vuc2UiOnRydWUsImZlYXR1cmVzIjp7ImRpc3BsYXlfbmlja25hbWVzIjpmYWxzZSwiY29udGVudF9tYW5hZ2VtZW50IjpmYWxzZSwiY2VydGlmaWNhdGVfbGlua2VkaW5fc2hhcmUiOmZhbHNlLCJhbGxvd19jaGFuZ2VfcHJpbWFyeV9jb3Vyc2UiOmZhbHNlfSwiaWF0IjoxNzEyNTYyMDEwLCJleHAiOjE3MTUxNTQwMTB9.HiFIP0vb6oqOe2_zuvXpxca5smZ6yRTet1DsTFGpElI',
            name: 'Codedefender',
            expiration: '1y',
            isNew: false,
            isExpired: false,
        },
        {
            id: 3,
            tenant: 'test',
            licenseId: 2,
            apiKey: '6d5503134f48a6cfb2c9759ab5d1887bf3909b00',
            encryptedToken: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX3V1aWQiOiI5MDQ0MzRiYS05ODU4LTQ5MjEtOWY1Ny1kNDcwMTdhNmVlZjciLCJ1c2VyX2lkIjoxLCJyb2xlIjoiY3VzdG9tZXJfYWRtaW4iLCJ1c2VyX2VtYWlsIjoiYWRtaW5AY29kZWJhc2hpbmcuY29tIiwidGVuYW50IjoibWF0cml4IiwiZW52IjpudWxsLCJsaWNlbnNlX2lkIjoyLCJpc19sZWFuX2xpY2Vuc2UiOnRydWUsImZlYXR1cmVzIjp7ImRpc3BsYXlfbmlja25hbWVzIjpmYWxzZSwiY29udGVudF9tYW5hZ2VtZW50IjpmYWxzZSwiY2VydGlmaWNhdGVfbGlua2VkaW5fc2hhcmUiOmZhbHNlLCJhbGxvd19jaGFuZ2VfcHJpbWFyeV9jb3Vyc2UiOmZhbHNlfSwiaWF0IjoxNzEyNTY3NTg5LCJleHAiOjE3MTQyOTU1ODl9.JypFrJS9TWteUCK2R6UeFV7V5Cqzavyqe213z8pH8J8',
            name: 'Platform',
            expiration: '2m',
            isNew: false,
            isExpired: true,
        },
    ],
};
exports.mockCreateApiCredentials = {
    success: true,
    apiCredential: {
        id: 4,
        tenant: 'test',
        licenseId: 2,
        apiKey: 'b510b26be889f26e87eb983559acde202a717ccb',
        encryptedToken: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX3V1aWQiOiI5MDQ0MzRiYS05ODU4LTQ5MjEtOWY1Ny1kNDcwMTdhNmVlZjciLCJ1c2VyX2lkIjoxLCJyb2xlIjoiY3VzdG9tZXJfYWRtaW4iLCJ1c2VyX2VtYWlsIjoiYWRtaW5AY29kZWJhc2hpbmcuY29tIiwidGVuYW50IjoibWF0cml4IiwiZW52IjpudWxsLCJsaWNlbnNlX2lkIjoyLCJpc19sZWFuX2xpY2Vuc2UiOnRydWUsImZlYXR1cmVzIjp7ImRpc3BsYXlfbmlja25hbWVzIjpmYWxzZSwiY29udGVudF9tYW5hZ2VtZW50IjpmYWxzZSwiY2VydGlmaWNhdGVfbGlua2VkaW5fc2hhcmUiOmZhbHNlLCJhbGxvd19jaGFuZ2VfcHJpbWFyeV9jb3Vyc2UiOmZhbHNlfSwiaWF0IjoxNzEyNTc0NTEwLCJleHAiOjE3MTI2ODI1MTB9.AE43tUaxF4w2GGOxUVQeD6jV_xaQpO4HvRtDal3P2xM',
        name: 'Core',
        expiration: '30d',
        isNew: false,
        isExpired: false,
    },
};
